<div class="scorecard" [class.active]="isActive" [style.--side-color]="participant?.color">
  <div class="head">
    <span class="name">{{ currLang === 'ar' ? participant?.displayName?.ar : participant?.displayName?.en }}</span>
    <span class="total">{{ (participant?.totalScore || 0) | arabicNumber:currLang }}</span>
  </div>
  <div class="row">
    <div class="cell"
         *ngFor="let frame of frames(); let i = index"
         [class.now]="i === currentFrame && isActive">
      <span class="v">{{ rollSymbol(frame) }}</span>
    </div>
  </div>
</div>
